import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import { solutionListings } from '@/mocks/solutions';

export default function SolutionEntries() {
  return (
    <section className="w-full px-4 md:px-6 pb-16 md:pb-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-3 mb-8 md:mb-10">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold tracking-wide whitespace-nowrap">
                <i className="ri-layout-grid-line"></i>
                全部解决方案
              </span>
              <h2 className="mt-4 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
                按行业场景选择整体解决方案
              </h2>
              <div className="mt-3 text-xs md:text-sm font-medium tracking-[0.32em] uppercase text-foreground-400">
                Solution Library
              </div>
              <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
                从农业生产到城市通行、餐饮经营与仓储物流，我们把可复用的 AIoT 硬件与平台能力沉淀为标准方案。
              </p>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {solutionListings.map((s, idx) => (
            <Reveal key={s.id} delay={idx * 70}>
              <Link
                to={s.href}
                className="group flex h-full flex-col rounded-2xl border border-background-200 bg-background-100 p-6 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:border-accent-300 hover:bg-background-50"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                  <i className={`${s.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-5 font-heading font-bold text-lg text-foreground-950 leading-snug">{s.title}</h3>
                <div className="text-xs text-foreground-500 mt-0.5">{s.en}</div>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">{s.desc}</p>
                <span className="mt-5 inline-flex items-center gap-1 text-xs font-medium text-accent-700 transition-transform duration-300 group-hover:translate-x-0.5">
                  查看方案
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}